module.exports = __webpack_public_path__ + "img/poineer.444f132d.png";